// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer__footer--3YOFg","anchor":"footer__anchor--3Zk9Q","apiVersion":"footer__apiVersion--3uxwS"};